export const getCandidateDisplayName = (resume = {}) => {
  const candidate = resume.candidateId || resume.candidate || {};
  const candidateFullName =
    candidate.fullName ||
    [candidate.firstName, candidate.lastName].filter(Boolean).join(" ");
  const isPlaceholderName =
    !candidateFullName || /unknown\s+candidate/i.test(candidateFullName);

  return (
    (!isPlaceholderName && candidateFullName) ||
    resume.parsedData?.candidateName ||
    "Unknown Candidate"
  );
};

export const getResumeSkills = (resume = {}) => {
  if (Array.isArray(resume.skills) && resume.skills.length) {
    return resume.skills;
  }
  if (
    Array.isArray(resume.parsedData?.skills) &&
    resume.parsedData.skills.length
  ) {
    return resume.parsedData.skills;
  }
  return [];
};

export const formatDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString();
};

export const formatExperience = (years) => {
  if (years === null || years === undefined || years === "") {
    return "-";
  }
  const num = Number(years);
  if (Number.isNaN(num)) return "-";
  return `${num} yrs`;
};

export const asArray = (value) => {
  if (!value) return [];
  return Array.isArray(value) ? value : [value];
};
